import angular from 'angular';
import viewModeToggle from './viewModeToggle';
import './style.scss';

export default angular
  .module('components.viewModeToggle', [])
  .component('viewModeToggle', viewModeToggle).name;
